
// import React, { useEffect, useState } from 'react'
// import HomeBanner from './home/HomeBanner'
// import PannaLatestNews from './home/PannaLatestNews'
// import OldNewsPanna from './home/OldNewsPanna'
// import PannaNews from './home/PannaNews'
// import GlobalNews from './home/GlobalNews'
// import HomeWorld from './home/HomeWorld'
// import HomePolitics from './home/HomePolitics'
// import HomeSports from './home/HomeSports'
// import HomeEntertainment from './home/HomeEntertainment'
// import HomeVideoGallery from './home/HomeVideoGallery'
// import HomeCrime from './home/HomeCrime'
// import AdvertiseBanner from './home/AdvertiseBanner'
// // import HomeNewsVideos from './home/HomeNewsVideos'
// import axios from 'axios'
// import Business from './business/Business'
// import Education from './education/Education'
// // import Country from './country/Country'
// // import Breaking from './breaking/Breaking'
// // import Crime from './crime/Crime'
// // import Politics from './politics/Politics'
// // import Sports from './sports/Sports'

// const Home = () => {
//   const [data, setData] = useState({
//     advertiseBanner: [],
//     homeBanner: [],
//     pannaLatestNews: [],
//     pannaNews: [],
//     globalNews: [],
//     homeWorld: [],
//     homePolitics: [],
//     homeSports: [],
//     oldNewsPanna: [],
//   });

//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchHomeData = async () => {
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_BASE_URL}api/v1/users/get-all-user`
//         );
//         console.log("data---00--", res.data);

//         // 🔍 Correct access paths according to your response JSON
//         const homeData = res.data?.data?.Home || {};
//         console.log("homeData", homeData)

//         setData({
//           advertiseBanner: homeData.advertiseBanner || [],
//           homeBanner: homeData.homeBanner || [],
//           pannaLatestNews: homeData.PannaLatestNews || [],
//           pannaNews: homeData.PannaNews || [],
//           globalNews: homeData.GlobalNews || [],
//           homeWorld: homeData.homeWorld || [],
//           homePolitics: homeData.HomePolitics || [],
//           homeSports: homeData.HomeSports || [],
//           oldNewsPanna: homeData.OldNewsPanna || [],
//         });
//       } catch (err) {
//         console.error("❌ Error fetching data:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchHomeData();
//   }, []);

//   if (loading) {
//     return <div className="text-center my-5">Loading...</div>;
//   }

//   console.log("home page data---", data);
//   return (
//     <>
//       <AdvertiseBanner  />
//       <HomeBanner  />

//       {/* <Breaking /> */}
//       <PannaLatestNews />

//       {/* <Country /> */}
//       <GlobalNews />

//       <PannaNews  />

//       {/* <World /> */}
//       <HomeWorld />

//       {/* <Politics /> */}
//       <HomePolitics />

//       <Business />

//       {/* <Crime /> */}
//       <HomeCrime/>

//       <Education />


//       {/* <Politics /> */}
//       <HomePolitics />

//       {/* <Sports /> */}
//       <HomeSports />

//       <HomeEntertainment />
//       <HomeVideoGallery />
//       <HomeCrime />
//       {/* <HomeNewsVideos /> */}
//       <OldNewsPanna data={data.oldNewsPanna} />
//     </>
//   );
// };

// export default Home;




import React from 'react';
import AdvertiseBanner from './home/AdvertiseBanner';
import HomeBanner from './home/HomeBanner';
import PannaLatestNews from './home/PannaLatestNews';
import GlobalNews from './home/GlobalNews';
import PannaNews from './home/PannaNews';
import HomeWorld from './home/HomeWorld';
import HomePolitics from './home/HomePolitics';
import Business from './business/Business';
import HomeCrime from './home/HomeCrime';
import Education from './education/Education';
import HomeSports from './home/HomeSports';
import HomeEntertainment from './home/HomeEntertainment';
import HomeVideoGallery from './home/HomeVideoGallery';
import OldNewsPanna from './home/OldNewsPanna';
import Cricket from './home/Cricket';
import Video from './home/Video';
import Weather from './home/Weather';

const Home = () => {
  return (
    <>
      <AdvertiseBanner />
      <HomeBanner />
      <Weather />
      <Video />
      <PannaLatestNews />
      <GlobalNews />
      <PannaNews />
      <HomeWorld />
      <HomePolitics />
      <Business />
      <HomeCrime />
      <Education />
      <HomeSports />
      {/* <OldNewsPanna /> */}
      <Cricket />
    </>
  );
};

export default Home;
